import { StoreSettings } from '../../Types/StoreTypes';

export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_DEMO = 'SET_DEMO';
export const SET_LOCAL_GROUPS = 'SET_LOCAL_GROUPS';
export const SET_API_BASE_URL = 'SET_API_BASE_URL';
export const SET_WEBSOCKET_URL = 'SET_WEBSOCKET_URL';
export const SET_OIDC_CONFIGURATION_URL = 'SET_OIDC_CONFIGURATION_URL';
export const SET_OIDC_LOGOUT_URL = 'SET_OIDC_LOGOUT_URL';
export const SET_OIDC_AUTHORITY = 'SET_OIDC_AUTHORITY';
export const SET_OIDC_CLIENT_ID = 'SET_OIDC_CLIENT_ID';
export const SET_OIDC_USER_IDENTIFIER = 'SET_OIDC_USER_IDENTIFIER';
export const SET_BUG_REPORTING = 'SET_BUG_REPORTING';
export const SET_REGISTRATION_ENABLED = 'SET_REGISTRATION_ENABLED';
export const SET_VERSION = 'SET_VERSION';
export const SET_DATA_PROTECTION_TEXT = 'SET_DATA_PROTECTION_TEXT';
export const SET_FEATURE_DOCUMENT_UPLOAD = 'SET_FEATURE_DOCUMENT_UPLOAD';
export const SET_CHANGELOGS = 'SET_CHANGELOGS';
export const SET_CHANGELOG_HASH = 'SET_CHANGELOG_HASH';
export const SET_BETA_ACTIVE = 'SET_BETA_ACTIVE';
export const SET_SENSITIVITY_LABELS = 'SET_SENSITIVITY_LABELS';
export const SET_SYSTEM_STATUS = 'SET_SYSTEM_STATUS';
export const SET_RELEASE_CHANNEL = 'SET_RELEASE_CHANNEL';
export const SET_RELOAD_SETTINGS = 'SET_RELOAD_SETTINGS';
export const TOGGLE_DEBUG_MODE = 'TOGGLE_DEBUG_MODE';

export function setSettings(settings: StoreSettings) {
    return { type: SET_SETTINGS, payload: settings };
}

export function setDemo(demo: StoreSettings['demo']) {
    return { type: SET_DEMO, payload: demo };
}

export function setLocalGroups(localGroups: StoreSettings['localGroups']) {
    return { type: SET_LOCAL_GROUPS, payload: localGroups };
}

export function setApiBaseUrl(apiBaseUrl: StoreSettings['apiBaseUrl']) {
    return { type: SET_API_BASE_URL, payload: apiBaseUrl };
}

export function setWebsocketUrl(websocketUrl: StoreSettings['websocketUrl']) {
    return { type: SET_WEBSOCKET_URL, payload: websocketUrl };
}

export function setOidcConfigurationUrl(oidcConfigurationUrl: StoreSettings['oidcConfiurationUrl']) {
    return { type: SET_OIDC_CONFIGURATION_URL, payload: oidcConfigurationUrl };
}

export function setOidcLogoutUrl(oidcLogoutUrl: StoreSettings['oidcLogoutUrl']) {
    return { type: SET_OIDC_LOGOUT_URL, payload: oidcLogoutUrl };
}

export function setOidcAuthority(oidcAuthority: StoreSettings['oidcAuthority']) {
    return { type: SET_OIDC_AUTHORITY, payload: oidcAuthority };
}

export function setOidcClientId(oidcClientId: StoreSettings['oidcClientId']) {
    return { type: SET_OIDC_CLIENT_ID, payload: oidcClientId };
}

export function setOidcUserIdentifier(oidcUserIdentifier: StoreSettings['oidcUserIdentifier']) {
    return { type: SET_OIDC_USER_IDENTIFIER, payload: oidcUserIdentifier };
}

export function setBugReporting(bugReporting: StoreSettings['bugreporting']) {
    return { type: SET_BUG_REPORTING, payload: bugReporting };
}

export function setRegistrationEnabled(registrationEnabled: StoreSettings['registrationEnabled']) {
    return { type: SET_REGISTRATION_ENABLED, payload: registrationEnabled };
}

export function setVersion(version: StoreSettings['version']) {
    return { type: SET_VERSION, payload: version };
}

export function setDataProtectionText(dataProtectionText: StoreSettings['dataProtectionText']) {
    return { type: SET_DATA_PROTECTION_TEXT, payload: dataProtectionText };
}

export function setFeatureDocumentUpload(featureDocumentUpload: StoreSettings['features']['documentUpload']) {
    return { type: SET_FEATURE_DOCUMENT_UPLOAD, payload: featureDocumentUpload };
}
export function setChangelogs(changelogs: StoreSettings['changelogs']) {
    return { type: SET_CHANGELOGS, payload: changelogs };
}

export function setChangelogHash(changelogHash: StoreSettings['changelogHash']) {
    return { type: SET_CHANGELOG_HASH, payload: changelogHash };
}

export function setBetaActive(betaActive: StoreSettings['betaActive']) {
    return { type: SET_BETA_ACTIVE, payload: betaActive };
}

export function setSensitivityLabels(sensitivityLabels: StoreSettings['sensitivityLabels']) {
    return { type: SET_SENSITIVITY_LABELS, payload: sensitivityLabels };
}

export function setSystemStatus(systemStatus: StoreSettings['systemStatus']) {
    return { type: SET_SYSTEM_STATUS, payload: systemStatus };
}

export function setReleaseChannel(releaseChannel: StoreSettings['releaseChannel']) {
    return { type: SET_RELEASE_CHANNEL, payload: releaseChannel };
}

export function setReloadSettings(reloadSettings: StoreSettings['reloadSettings']) {
    return { type: SET_RELOAD_SETTINGS, payload: reloadSettings };
}

export function toggleDebugMode() {
    return { type: TOGGLE_DEBUG_MODE };
}
